import React from 'react';

const NotFound = () => (
  <div className="col-md-9 content">
    <div className="alert alert-danger text-center" role="alert">
      Sorry, page not found.
    </div>
  </div>
);

export default NotFound;



// WEBPACK FOOTER //
// ./src/modules/core/components/NotFound.js